export const EDITION_BT_LINK = "/";
export const EDITION_BTG_LINK = "/global";

export const CHINESE_EDITION = {
  link: "/zh-hans",
  text: "中文版",
  textBeta: "(beta)",
};
